import { Switch } from "antd";
import MasterComponent from "../../components/Forms";
import { MasterConfigs } from "../../interfaces/entity";
import { putData } from "../../actions/developer";
import { useDispatch } from "react-redux";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const WorkflowList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const onChange = async (id, status) => {
        const resData = await dispatch(putData(`/work-flow/${id}`, { ruleStatus: status }));
        if (resData) {
            dispatch({
                type: 'REFRESH_TABLE',
                refreshTable: true
            })
        }

    }


    const config: MasterConfigs = {
        api: () => '/work-flow',
        modalTitle: () => 'Workflow',
        isActionTab: true,
        getColumns: () => [
            {
                title: 'Rule Name', dataIndex: 'ruleName', key: 'ruleName',
                render: (text, record) => {
                    return <a onClick={() => navigate(`work-flow-ui/${record?._id}/?module=${record.moduleName}`)}> {text} </a>
                }
            },
            { title: 'Modules', dataIndex: 'moduleName', key: 'moduleName' },
            { title: 'Execute On', dataIndex: 'executeOn', key: 'executeOn' },
            { title: 'Action', dataIndex: 'action', key: 'action' },
            {
                title: 'Modified On', dataIndex: 'updatedAt', key: 'updatedAt',
                render: (text) => {
                    return text ? moment(text).format('lll') : '-'
                },
                align: 'center',
            },
            {
                title: 'Rule Status', dataIndex: 'ruleStatus', key: 'ruleStatus',
                align: 'center',
                render: (text, record) => {
                    return <Switch checked={text == 'active'} size="small" onChange={() => onChange(record._id, text == 'active' ? 'inactive' : 'active')} />
                }
            },
        ],
        getFormColumns: () => [
            {
                label: 'Rule Name', dataIndex: 'ruleName', name: 'ruleName', type: 'text',
                rules: [{ required: true, message: 'Please input a rule name!' }],
            },
            {
                label: 'Module Name', dataIndex: 'moduleName', name: 'moduleName', type: 'select',
                children: [
                    { value: 'leads', name: 'leads' }],
                rules: [{ required: true, message: 'Please select a module name!' }],
            },
        ],
        actions: [
            { actionType: 'Add', name: 'Add' },
        ]
    }

    return (
        <MasterComponent config={config} isModal={true} />
    );

}
export default WorkflowList;